import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { Process } from "@/components/Process";
import { About } from "@/components/About";
import { Partners } from "@/components/Partners";
import { Enquiry } from "@/components/Enquiry";
import { Footer } from "@/components/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page">
      <Nav />
      <Hero />
      <Services />
      <Process />
      <About />
      <Partners />
      <Enquiry />
      <Footer />
    </main>
  );
}
